export default __webpack_public_path__ + "static/RTG_PDP_LOGO_RTGPATIO_835x100-060ca186b5e5afa178f71f4e1483d7c9.png";